import { default as DataMappingForm } from "./DataMappingForm";

export default DataMappingForm;
